import CircularProgress from '@mui/material/CircularProgress';

export default function CircularUnderLoad() {
  return (
    // @focus @padding 2
    <CircularProgress disableShrink aria-label="Loading…" />
  );
}
